import * as React from 'react';
import { useStableCallback } from './use-stable-callback';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = (cb, delay = 3000) => {
    const latestCallback = useStableCallback(cb);
    const latestTimerId = React.useRef();
    React.useEffect(() => {
        return function cleanup() {
            if (latestTimerId.current) {
                clearTimeout(latestTimerId.current);
            }
        };
    }, []);
    return React.useCallback(function cb(...args) {
        if (latestTimerId.current) {
            clearTimeout(latestTimerId.current);
        }
        latestTimerId.current = setTimeout(() => {
            latestCallback(...args);
        }, delay);
    }, []);
};
//# sourceMappingURL=use-debounced-callback.js.map